// @systeme: interface
// Les interrupteurs : éteindre une fonctionnalité la cache dans l'app et la refuse côté
// serveur, sans déploiement. Pour un souci, une pause, un test.
import { useEffect, useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { Fonctionnalites, type Fonctionnalite, type Interrupteurs as Etat } from '@foyer/shared';
import { Chargement } from '../../composants/Chargement';
import { useMessages } from '../../composants/Messages';
import { api } from '../../lib/api';

const LIBELLES: Record<Fonctionnalite, string> = {
  photos: 'Photographier un document',
  vide_ma_tete: 'Je vide ma tête (le vocal long)',
  partage_listes: 'Partager une liste par lien',
  invitations: 'Inviter quelqu’un dans son foyer',
  preparations: 'Préparer à rebours (rétro-planning)',
};

export function Interrupteurs() {
  const { dire, direErreur } = useMessages();
  const [etat, setEtat] = useState<Etat | undefined>();

  useEffect(() => {
    api.admin.interrupteurs().then(setEtat).catch(direErreur);
  }, [direErreur]);

  async function basculer(cle: Fonctionnalite, actif: boolean) {
    if (!etat) return;
    const suivant = { ...etat, [cle]: actif };
    try {
      await api.admin.modifierReglage('fonctionnalites', suivant);
      setEtat(suivant);
      dire(
        actif ? 'Rallumé.' : 'Éteint. La fonction disparaît de l’app dès la prochaine ouverture.',
      );
    } catch (e) {
      direErreur(e);
    }
  }

  if (!etat) return <Chargement />;
  return (
    <Stack spacing={1}>
      <Typography color="text.secondary" sx={{ mb: 1 }}>
        Ce qui est éteint n’apparaît plus dans l’app et le serveur le refuse. Rien n’est supprimé :
        rallumer remet tout en place.
      </Typography>
      {Fonctionnalites.map((cle) => (
        <FormControlLabel
          key={cle}
          control={
            <Switch
              checked={etat[cle] !== false}
              onChange={(e) => void basculer(cle, e.target.checked)}
            />
          }
          label={LIBELLES[cle]}
        />
      ))}
    </Stack>
  );
}
